// role_id values from the backend's roles table (1-based position in its ROLES).
export const ROLE_IDS = {
  SYSTEM_ADMIN: 1,
  ADMIN: 2,
  PERSONNEL_MANAGER: 3,
  OPERATIONS_MANAGER: 4,
  AGRONOMIST: 5
}

// The system admin is platform-level: no farm, only the System section.
export const isSystemAdmin = user => Number(user?.roleId) === ROLE_IDS.SYSTEM_ADMIN
